'use strict';

const STATE = {
  // 未発注
  NEED_PURCHASE: 'need_purchase',
  // 発注済み
  PURCHASED: 'purchased',
  // 入荷待ち
  //   商品の入荷待ちのため配送できない状態
  PENDING_BY_BACK_ORDERED: 'pending_by_back_ordered',
  // 配送可能
  ORDERED: 'ordered',
  // 配送フローで商品をピックアップ済み
  PICKUPED: 'pickuped',
  // 配送済み
  SHIPPED: 'shipped',
  // 配送完了
  DELIVERED: 'delivered',
  // キャンセルリクエスト済み
  CANCEL_REQUESTED: 'cancel_requested',
  // キャンセル済み
  REFUNDED: 'refunded',
  // 保留 (なんらかの理由により)
  PENDING: 'pending',
  // 返送済み
  //   ユーザーが受け取らず or 住所が間違っているなどの理由により、
  //   倉庫に荷物が返送されてきた状態
  RETURNED: 'returned'
};

const STATE_PATTERN = [
  STATE.NEED_PURCHASE,
  STATE.PURCHASED,
  STATE.PENDING_BY_BACK_ORDERED,
  STATE.ORDERED,
  STATE.PICKUPED,
  STATE.SHIPPED,
  STATE.DELIVERED,
  STATE.CANCEL_REQUESTED,
  STATE.REFUNDED,
  STATE.PENDING,
  STATE.RETURNED
];

module.exports = {
  STATE,
  STATE_PATTERN
};
